import { Injectable } from '@angular/core';
import { BaleAbstractService } from '~/services/api/web/bale/baleAbstractService';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClientWrapper } from '~/services/api/httpClientWrapper';
import { BaseWebService } from '~/services/api/web/base/baseWebService';
import { ResponseModel } from '~/models/responseModel';
import { BaleModel } from '~/models/baleModel';
import { ClipModel } from '~/models/clipModel';
import { Observable } from 'rxjs';
import { map as _map } from 'lodash';
import { InventoryBaleModel } from '~/models/inventoryBaleModel';
import { BreakDownModel, MobBreakDownModel } from '~/models/breakDownModel';
import { EntityModel } from '~/models/entityModel';
import { BrandModel } from '~/models/brandModel';
import { SpeciSummaryModel } from '~/models/speciSummaryModel';
import { ClipSummaryModel } from '~/models/clipSummaryModel';
import { MobSummaryModel } from '~/models/mobSummaryModel';
import { LineLotSummaryModel } from '~/models/lineLotSummaryModel';

@Injectable()
export class BaleService extends BaseWebService implements BaleAbstractService {

    public static readonly PATH:string = '/bales';

    constructor(http: HttpClientWrapper) {
        super(http);
    }

    public getBaleById(baleId: number): Observable<ResponseModel> {
        let url:string = BaleService.URL + BaleService.PATH + '/' + baleId.toString();

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new InventoryBaleModel(response['data']);
        });
    }

    public getMobsByBaleId(baleId: number): Observable<ResponseModel> {
        let url:string = BaleService.URL + BaleService.PATH + '/' + baleId.toString() + '/mobs';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new MobSummaryModel(mob));
        });
    }

    public getLinesAndLotsByBaleId(baleId: number): Observable<ResponseModel> {
        let url:string = BaleService.URL + BaleService.PATH + '/' + baleId.toString() + '/linesandlots';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new LineLotSummaryModel(mob));
        });
    }

    public getClipsByBaleId(baleId: number): Observable<ResponseModel> {
        let url:string = BaleService.URL + BaleService.PATH + '/' + baleId.toString() + '/clips';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new ClipSummaryModel(mob));
        });
    }

    public getSpecisByBaleId(baleId: number): Observable<ResponseModel> {
        let url:string = BaleService.URL + BaleService.PATH + '/' + baleId.toString() + '/specis';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new SpeciSummaryModel(mob));
        });
    }


    public getBaleAverage(baleId: number): Observable<ResponseModel> {
        let url:string = BaleService.URL + BaleService.PATH + '/' + baleId.toString() + '/average';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new BreakDownModel(response['data']);
        });
    }

    public getMobBreakDownByBale(baleId: number): Observable<ResponseModel> {
        let url:string = BaleService.URL + BaleService.PATH + '/' + baleId.toString() + '/mob-breakdown';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (model:{}) => new MobBreakDownModel(model));
        });
    }
}
